import React from 'react';


const CancelOrder = ({ setInputModal }) => {


    return (
        <div style={{ display: 'grid', gap: '1rem' }}>
            <div>Are you sure you want to cancel the order?</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <button className='btn' style={{ backgroundColor: '#fabc42', paddingInline: '3rem', color: 'white' }} onClick={() => setInputModal(false)}>No</button>
                <button className='btn' style={{ backgroundColor: '#f5f5f5', paddingInline: '3rem' }}>Yes</button>
            </div>
        </div>
    )
}

export default CancelOrder